module.exports = __webpack_public_path__ + "img/JBS-alt.45ef0e65.svg";